//angular
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { AddressTypeValues, collectionOfAddressType, VisibleState } from 'src/app/app.data';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { Country, POST_AddressInterface, Put_AddressInterface, RestResponse} from 'src/app/_shared/models';
import { CustomerAddressBook } from 'src/app/_shared/models/customer.model';
import { LoaderService } from 'src/app/_core/services';
import { ValidatorService } from '../../../../../_shared/validators/validator.service';
import { SharedCustomerService } from 'src/app/_core/services/api/shared-customer.service';
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  selector: 'app-customer-addressbook',
  templateUrl: './customer-addressbook.component.html'
})
export class DialogCustomerAddressbookComponent implements OnInit, OnDestroy {
  collectionOfCountry: Array<Country> = [];
  collectionOfCustomerAddressBook: Array<CustomerAddressBook> = [];
  selectedAddress: any;
  disableSaveAddress: boolean = false;
  statusNewAddressPanel: VisibleState = VisibleState.isHidden;
  form: FormGroup;
  collectionOfAddressType: Array<DropDown> = collectionOfAddressType;
  isFormReady: boolean = false;
  formSubmitted: boolean = false;
  private subs = new Unsubscriber();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogCustomerAddressbookComponent>,
    private _iconRegistry: MatIconRegistry,
    private _fb: FormBuilder,
    private _loader: LoaderService,
    private _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private sharedCustomerService: SharedCustomerService,
    private sharedGlobalService: SharedGlobalService,
    private _validatorService: ValidatorService,
  ) {

    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));

    this.getCountries().then((res: RestResponse) => {
      this.collectionOfCountry = <Array<Country>>res.data;
    }).catch((err: RestResponse) => {
      console.log('@@@errGetCountries', err);
    });
  }

  setUpForm() {
    this.form = this._fb.group({
      addressData: this._fb.group({
        city: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
        contactCompany: '',
        contactEmail: '',
        firstName: '',
        lastName: '',
        contactPhone: '',
        countryId: '',
        state: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(2), Validators.maxLength(255)]],
        street1: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
        street2: ['', [this._validatorService.emptySpace, Validators.minLength(1), Validators.maxLength(255)]],
        type: new FormControl(AddressTypeValues.residential),
        zip: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
      }),
      saveAddress: ''
    });
  }

  getCountries() {
    return this.sharedGlobalService.getCountries().toPromise();
  }

  getCustomerAddressbooksById(_customerId) {
    //Get Customer's address book & charges
    this.subs.addSub = this.sharedCustomerService.getAddressBookByCustomerId(_customerId).subscribe(
      (res: RestResponse) => {
        this.isFormReady = true;
        this.collectionOfCustomerAddressBook = <Array<CustomerAddressBook>>res.data;
        this.selectedAddress = (this.collectionOfCustomerAddressBook.length > 0 ? this.collectionOfCustomerAddressBook[0] : '0');
        this.setAddress(this.selectedAddress);
      },
      (err: RestResponse) => {
        this.isFormReady = true;
        console.log('@@@errAddressBook',err);
      }
    )
  }

  ngOnInit(): void {
    this.setUpForm();
    this.getCustomerAddressbooksById(this.data.customer.id);
    this.disableSaveAddress = this.data.disableSaveAddress;
    this.form.get('saveAddress').setValue(this.data.saveAddress);

  }

  setAddress(_address: any) {
    let addressData = <FormGroup>this.form.get('addressData');
    if (_address !== '0') {
      let address = new CustomerAddressBook().deserialize(_address);
      addressData.get('city').setValue(address.city);
      addressData.get('firstName').setValue(address.firstName);
      addressData.get('lastName').setValue(address.lastName);
      addressData.get('countryId').setValue(address.country.id);
      addressData.get('state').setValue(address.state);
      addressData.get('street1').setValue(address.street1);
      addressData.get('street2').setValue(address.street2);
      addressData.get('zip').setValue(address.zip);
      this.statusNewAddressPanel = VisibleState.isHidden;
    } else {
      addressData.get('city').setValue('');
      addressData.get('firstName').setValue('');
      addressData.get('lastName').setValue('');
      addressData.get('countryId').setValue(240);
      addressData.get('state').setValue('');
      addressData.get('street1').setValue('');
      addressData.get('street2').setValue('');
      addressData.get('zip').setValue('');
      this.statusNewAddressPanel = VisibleState.isVisible;
    }
  }

  onClose() {
    this._dialogRef.close();
  }

  onChangeAddress(_selectedValue: any){
    this.selectedAddress = _selectedValue;
    this.setAddress(this.selectedAddress);
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }
    if ( this.statusNewAddressPanel == VisibleState.isHidden) {
    //select from dropdown list
      let bodyParams: POST_AddressInterface = {
        city: null,
        contactName: null,
        countryId: null,
        state: null,
        street1: null,
        street2: null,
        type: null,
        zip: null,
        firstName: null,
        lastName: null,
      }

      bodyParams.city = this.selectedAddress.city;
      bodyParams.contactName = `${this.selectedAddress.firstName} ${this.selectedAddress.lastName}`;
      bodyParams.firstName = this.selectedAddress.firstName;
      bodyParams.lastName = this.selectedAddress.lastName;
      bodyParams.countryId = this.selectedAddress.country.id;
      bodyParams.state = this.selectedAddress.state;
      bodyParams.street1 = this.selectedAddress.street1;
      bodyParams.street2 = this.selectedAddress.street2;
      bodyParams.type = this.selectedAddress.type;
      bodyParams.zip = this.selectedAddress.zip;
      bodyParams.id = this.selectedAddress.id;

      this._loader.stopLoader();
      this._dialogRef.close({ newAddress:  bodyParams });
    } else {
      //new address

      let bodyParams: POST_AddressInterface = {
        city: null,
        contactName: null,
        countryId: null,
        state: null,
        street1: null,
        street2: null,
        type: null,
        zip: null,
        firstName: null,
        lastName: null,
      }

      bodyParams.city = this.form.get('addressData').get('city').value;
      bodyParams.contactName = `${this.form.get('addressData').get('firstName').value} ${this.form.get('addressData').get('lastName').value}`;
      bodyParams.firstName = this.form.get('addressData').get('firstName').value;
      bodyParams.lastName = this.form.get('addressData').get('lastName').value;
      bodyParams.countryId = this.form.get('addressData').get('countryId').value;
      bodyParams.state = this.form.get('addressData').get('state').value;
      bodyParams.street1 = this.form.get('addressData').get('street1').value;
      bodyParams.street2 = this.form.get('addressData').get('street2').value;
      bodyParams.type = this.form.get('addressData').get('type').value;
      bodyParams.zip = this.form.get('addressData').get('zip').value;

      this._loader.startPageLoader();
      if (this.form.valid && this.form.get('saveAddress').value) {
        this.subs.addSub = this.sharedCustomerService.createAddressBookByCustomerId(this.data.customer.id, bodyParams).subscribe(
          (res: RestResponse) => {
            this._loader.stopPageLoader();
            const newAddress = <CustomerAddressBook>res.data;
            bodyParams.id = newAddress.id;
            this._dialogRef.close({ newAddress: bodyParams })
            this._meta.showNotification(res);
            this.formSubmitted = !this.formSubmitted;
          },
          (err: RestResponse) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(err);
          });
      } else {
        this._loader.stopLoader();
        bodyParams.id = this.selectedAddress.id;
        this._dialogRef.close({ newAddress: bodyParams })
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
